import { Injectable } from '@angular/core';
import { Component, OnInit, Inject } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { AuthenticationService } from 'app/components/sessions/login/auth.service';
import { JwtUser } from 'app/model/jwt-user';
const TOKEN_KEY = 'token';

@Injectable()
export class AuthGuardService implements CanActivate {
  tokenDetails: any;
  loginDetails: any;
  userDetailsObj: any;
  landingResponse: any;
  taskOpen: any;
  TOKEN = 'token';
  USER_NAME = 'authenticatedUser';
  USER_TEAM_TYPE = 'userTeamType';
  USER_EMAIL = 'email';
  CLIENT_LIST = 'clientList';
  TIME_OFFSET = 'timeOffset';
  MENU_LIST = 'menulist';
  userTeamType: string;
  defaultHomeScreenId: string;
  defaultHomeScreenUrl: string;

  jwtUser: JwtUser = new JwtUser();
  sessionAuthenticatedResult: any;

  constructor(
    private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private authenticationService: AuthenticationService
  ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (route.fragment) {
      const fragmentArr = route.fragment.split('&');
      if (fragmentArr.length == 6) {
        const auth = fragmentArr[0];
        const authArr = auth.split('=');

        const token = fragmentArr[1];
        const tokenArr = token.split('=');

        const winUserId = fragmentArr[2];
        const winUserIdArr = winUserId.split('=');

        const domain = fragmentArr[3];
        const domainArr = domain.split('=');

        const sessionId = fragmentArr[4];
        const sessionIdArr = sessionId.split('=');

        const userTeamType = fragmentArr[5];
        const userTeamTypeArr = userTeamType.split('=');

        //localStorage.clear();
        if (authArr[0] == 'auth' && authArr[1] == 'true') {
          if (tokenArr[0] == 'TOKEN') {
            this.authenticationService.registerSuccessfulLogin(
              '',
              tokenArr[1],
              '',
              userTeamTypeArr[1],
              '',
              '',
              '',
              '',
              ''
            );
            this.jwtUser.token = tokenArr[1];
            this.jwtUser.sessionId = sessionIdArr[1];
            this.jwtUser.winUserID = winUserIdArr[1];
            this.jwtUser.domain = winUserIdArr[1];

            this.authenticationService.sessionAuthentication(this.jwtUser).subscribe(result => {
              this.sessionAuthenticatedResult = result;

              if (this.sessionAuthenticatedResult.status == 1) {
                this.authenticationService.afterLoginUserDetail(tokenArr[1]).subscribe(result => {
                  this.userTeamType = localStorage.getItem('userTeamType');
                  //Added on 13-Dec-2024 -- start
                  this.defaultHomeScreenId = localStorage.getItem('defaultHomeScreenId');
                  this.defaultHomeScreenUrl = localStorage.getItem('defaultHomeScreenUrl');

                  if (this.defaultHomeScreenId != null) {
                    this.router.navigate([this.defaultHomeScreenUrl]);
                  }
                  //Added on 13-Dec-2024 -- end
                  else if (this.userTeamType == 'Auditee Area') {
                    this.router.navigate(['/auditeehome/auditeehome']);
                  } else {
                    this.router.navigate(['/auditorhome/auditorhome']);
                  }
                  return false;
                });
                return false;
              } else {
                this.router.navigate(['/login']);
                return false;
              }
            });
          }
        }
      } else {
        this.router.navigate(['/login']);
        return false;
      }
    }

    if (this.authenticationService.isUserLoggedIn()) {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
